import { TouristGroup } from '@ve/types';

export default (model: Backbone.Model): TouristGroup | null => {
    if (!model) return null;
    return {
        adults: model?.get('adults'),
        kids: model?.get('kids'),
        infants: model?.get('infants'),
        ages: model?.get('ages') || [],
        touristsByRooms: model?.get('touristsByRooms') || [],
    };
};
